
import { EnvGlobalsHandler, SimpleCommand } from "@goodgamestudios/core";

import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";

export class Poker2InitServerListCommand extends SimpleCommand {
    public execute(commandVars: any = null): void {
        /*
        EnvGlobalsHandler.globals.sfsServerList = new ServerListVO;

        if (EnvGlobalsHandler.globals.isTest || EnvGlobalsHandler.globals.isLocal) {
            EnvGlobalsHandler.globals.sfsServerList.addServer(new ServerVO("83.141.16.10", 443, "Poker2Ex", -1, "default", "QA-TEST"));
            EnvGlobalsHandler.globals.sfsServerList.addServer(new ServerVO("192.168.1.182", 443, "Poker2Ex", -2, "default", "Timo"));
            EnvGlobalsHandler.globals.sfsServerList.addServer(new ServerVO("192.168.1.135", 443, "Poker2Ex", -2, "default", "Erik"));
            EnvGlobalsHandler.globals.sfsServerList.addServer(new ServerVO("192.168.1.78", 443, "Poker2Ex", -2, "default", "Martin"));
            EnvGlobalsHandler.globals.sfsServerList.addServer(new ServerVO("127.0.0.1", 443, "Poker2Ex", -3, "default", "Lokal"));
        }

        for (let entryList of commandVars.serverInstances) {
            var instanceData: any = entryList;
            if (instanceData === undefined) continue;
            EnvGlobalsHandler.globals.sfsServerList.addServer(new ServerVO(instanceData.server.text(), parseInt(instanceData.port.text()), instanceData.zone.text(), parseInt(instanceData["value"]), instanceData.defaultlanguage.text()));
        }
        */
    }
}
classImplementsInterfaces(Poker2InitServerListCommand, "ISimpleCommand");
